module.exports = __webpack_public_path__ + "img/cert_logo.2201f57c.png";